/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Assistant_Activity_FailedInputs */



/**
* | output |
* | --- |
* | "{tool} failed" |
*
* @param {Assistant_Activity_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_failed = /** @type {((inputs: Assistant_Activity_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.tool} a échoué`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.tool} fehlgeschlagen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.tool} non è riuscito`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.tool} не удалось`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.tool} falló`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.tool} 失败`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.tool} が失敗しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.tool} विफल हो गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.tool} falhou`)
	return /** @type {LocalizedString} */ (`${i?.tool} failed`)
});